import { render, staticRenderFns } from "./cargoInformation.vue?vue&type=template&id=7195c7d6&"
import script from "./cargoInformation.vue?vue&type=script&lang=js&"
export * from "./cargoInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7195c7d6')) {
      api.createRecord('7195c7d6', component.options)
    } else {
      api.reload('7195c7d6', component.options)
    }
    module.hot.accept("./cargoInformation.vue?vue&type=template&id=7195c7d6&", function () {
      api.rerender('7195c7d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/cargoInformation.vue"
export default component.exports